module.exports = __webpack_public_path__ + "img/wine-bottle.c6f18dea.svg";